"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { useErrorAutoReload } from "@/app/hooks/useErrorAutoReload";
import { isModuleGraphError } from "@/app/lib/isModuleGraphError";
import { reportClientError } from "@/app/lib/reportClientError";
import { trackGeneric } from "@/app/lib/tracking/interactions";

interface PagesErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function PagesError({ error, reset }: PagesErrorProps) {
  const willReload = useErrorAutoReload();
  const graphError = isModuleGraphError(error);

  useEffect(() => {
    console.error("[pages/error]", error.digest ?? "(no digest)", error);
    reportClientError(error, "pages");
    Sentry.captureException(error);
    if (willReload) void Sentry.flush(120).catch(() => {});
    trackGeneric(willReload ? "page_error_auto_reload" : "page_error", "view");
  }, [error, willReload]);

  if (willReload) return null;

  return (
    <div className="container-main flex flex-col items-center justify-center py-24 gap-4 text-center">
      <p className="text-gray-500 text-sm">Sayfa yuklenirken bir hata olustu.</p>
      <button
        onClick={() => {
          trackGeneric("page_error_retry", "click");
          if (graphError) window.location.reload();
          else reset();
        }}
        className="px-5 py-2 rounded-lg bg-main text-white text-sm hover:bg-main/90 transition-colors"
      >
        Tekrar Dene
      </button>
    </div>
  );
}